import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    loading: false,
    allPermissions: [],
    modules: [],
    catalog: [],
    myPermissions: null,
    roles: [],
    rolesLoading: false,

    updateLoading: false,
    updateRes: null,

    createRoleLoading: false,
    createRoleRes: null,
    deleteRoleLoading: false,
    deleteRoleRes: null,
};

const permissionsSlice = createSlice({
    name: 'permissions',
    initialState,
    reducers: {
        getAllRequest: (state) => {
            state.loading = true;
        },
        getAllSuccess: (state, action) => {
            state.loading = false;
            state.allPermissions = action.payload.data || [];
            state.modules = action.payload.modules || [];
            state.catalog = action.payload.catalog || [];
        },
        getAllFailure: (state) => {
            state.loading = false;
        },

        getMyRequest: (state) => {
            state.loading = true;
        },
        getMySuccess: (state, action) => {
            state.loading = false;
            state.myPermissions = action.payload.data || null;
        },
        getMyFailure: (state) => {
            state.loading = false;
        },

        updateAllRequest: (state) => {
            state.updateLoading = true;
        },
        updateAllSuccess: (state, action) => {
            state.updateLoading = false;
            state.updateRes = action.payload;
        },
        updateAllFailure: (state, action) => {
            state.updateLoading = false;
            state.updateRes = action.payload;
        },
        resetUpdateRes: (state) => {
            state.updateRes = null;
        },

        getRolesRequest: (state) => {
            state.rolesLoading = true;
        },
        getRolesSuccess: (state, action) => {
            state.rolesLoading = false;
            state.roles = action.payload.data || [];
        },
        getRolesFailure: (state) => {
            state.rolesLoading = false;
        },

        createRoleRequest: (state) => {
            state.createRoleLoading = true;
            state.createRoleRes = null;
        },
        createRoleSuccess: (state, action) => {
            state.createRoleLoading = false;
            state.createRoleRes = action.payload;
        },
        createRoleFailure: (state, action) => {
            state.createRoleLoading = false;
            state.createRoleRes = action.payload;
        },
        resetCreateRoleRes: (state) => {
            state.createRoleRes = null;
        },

        deleteRoleRequest: (state) => {
            state.deleteRoleLoading = true;
            state.deleteRoleRes = null;
        },
        deleteRoleSuccess: (state, action) => {
            state.deleteRoleLoading = false;
            state.deleteRoleRes = action.payload;
        },
        deleteRoleFailure: (state, action) => {
            state.deleteRoleLoading = false;
            state.deleteRoleRes = action.payload;
        },
        resetDeleteRoleRes: (state) => {
            state.deleteRoleRes = null;
        },

        clearPermissions: (state) => {
            state.myPermissions = null;
            state.allPermissions = [];
            state.modules = [];
            state.catalog = [];
            state.roles = [];
        },
    },
});

export const {
    getAllRequest,
    getAllSuccess,
    getAllFailure,
    getMyRequest,
    getMySuccess,
    getMyFailure,
    updateAllRequest,
    updateAllSuccess,
    updateAllFailure,
    resetUpdateRes,
    getRolesRequest,
    getRolesSuccess,
    getRolesFailure,
    createRoleRequest,
    createRoleSuccess,
    createRoleFailure,
    resetCreateRoleRes,
    deleteRoleRequest,
    deleteRoleSuccess,
    deleteRoleFailure,
    resetDeleteRoleRes,
    clearPermissions,
} = permissionsSlice.actions;

export default permissionsSlice.reducer;
